<template>
</template>

<script>
import { $_TYPE, $_ADM, $_WC } from '@/confs/common.const';
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";
import simpleMapMixins from '@/stores/simple.map.mixin';

import { mapGetters } from "vuex";
export default {
    data(){
        return {
            groupName: 'seoulSimplemap',
        };
    },
    computed: {
        ...mapGetters({
            simpleMap: 'getSimpleMap',
            topMenuList: 'getTopMenuList',
            selectedTopMenu: 'getSelectedTopMenu',
            showSeoulmap: 'getShowSeoulmap',
            safetySggCenterMap: 'getSafetySggCenterMap',
            accidentSggCenterMap: 'getAccidentSggCenterMap',
            airSggList: 'getAirSggList',
            waterSggCenterMap: 'getWaterSggCenterMap',
            airHjdMeta: 'getAirHjdMeta',
            selectedSubMenus: 'getSelectedSubMenus',
            waterHjdMeta: 'getWaterHjdMeta',
            seoulMapMenu: 'getSeoulMapMenu',
            seoulRainfallMap: 'getSeoulRainfallMap',
        }),
        airSggCenterMap(){
            return gripUtil.toDict(this.airSggList, 'val2');
        },
    },
    watch: {
        selectedTopMenu: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.seoulMapCtrl();
            }
        },
        showSeoulmap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(newVal) {
                    this.$nextTick(() => {
                        this.seoulMapCtrl();
                    });
                }
            }
        },
        seoulMapMenu: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.drawAir();
            }
        },
        safetySggCenterMap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                // 초기 로딩 세팅
                if($_WC.responsiveScale === 3) {
                    if(Object.keys(newVal).length > 0 && Object.keys(oldVal).length === 0) {
                        if(this.selectedTopMenu !== 'Realcity') {
                            this.$store.dispatch('SET_SHOW_SEOULMAP', true);
                        }
                    }
                }
            }
        },
        airSggCenterMap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.drawAir();
            }
        },
        waterSggCenterMap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.drawWater();
            }
        },
    },
    created() {
        this.$eventBus.$on("SimpleMap::completed-simple-map-draw", (gripSimpleMap)=>{
            this.$store.dispatch('SET_SIMPLE_MAP', gripSimpleMap);
            this.seoulMapCtrl();
        });
    },
    methods: {
        seoulMapCtrl(){
            if(typeof this['draw' + this.selectedTopMenu] === $_TYPE.FUNC) {
                if(this.selectedTopMenu != 'Realcity' && !$_WC.isMobile) {
                    this.$store.dispatch('SET_SHOW_SEOULMAP', true);
                }
                this['draw' + this.selectedTopMenu]();
            }
        },
        drawRealcity() {
            if(typeof this.simpleMap !== $_TYPE.UNDEF && this.selectedTopMenu === 'Realcity') {
                // this.initGripSeoulSimpleMap();
                this.$store.dispatch('SET_SHOW_SEOULMAP', false);
            }
        },
        drawSafety(){
            if(typeof this.simpleMap !== $_TYPE.UNDEF && this.selectedTopMenu === 'Safety') {
                this.initGripSeoulSimpleMap();
                this.$store.dispatch('SET_SHOW_SEOULMAP', true);
                for(let sggNm in $_ADM.GU_CENTER_MAP) {
                    let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                    let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;

                    let fillColor = '#cccccc';
                    if(sggNm === '강남구') {
                        fillColor = '#ffd401';
                    }
                    let textSize = [];
                    let text = [];
                    let textColor = [];

                    let count = 0;
                    if(typeof this.safetySggCenterMap[sggNm] !== $_TYPE.UNDEF) {
                        count = this.safetySggCenterMap[sggNm].count;
                    }
                    textSize.push(10);
                    text.push(count);
                    textColor.push('#ffffff');

                    textSize.push(8);
                    text.push(sggNm);
                    textColor.push('#333333');

                    this.simpleMap.changePathColor(escape(sggNm), fillColor);
                    this.simpleMap.addEllipse(this.groupName, lat, lng, 15, 7, 0, 0, "#688b9f", 0.4);
                    this.simpleMap.addText(this.groupName, lat, lng, textSize, textColor, text, undefined, 0.2);
                }
            }
        },
        drawAccident(){
            if(typeof this.simpleMap !== $_TYPE.UNDEF && this.selectedTopMenu === 'Accident') {
                this.initGripSeoulSimpleMap();
                this.$store.dispatch('SET_SHOW_SEOULMAP', true);
                let standardCount = 0;
                if(typeof this.accidentSggCenterMap['강남구'] !== $_TYPE.UNDEF) {
                    standardCount = this.accidentSggCenterMap['강남구'].count;
                }
                for(let sggNm in $_ADM.GU_CENTER_MAP) {
                    let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                    let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;

                    let count = 0;
                    if(typeof this.accidentSggCenterMap[sggNm] !== $_TYPE.UNDEF) {
                        count = this.accidentSggCenterMap[sggNm].count;
                    }

                    let fillColor = '#cccccc';
                    if(sggNm === '강남구') {
                        fillColor = '#ffd401';
                    } else {
                        if(count > standardCount){
                            fillColor = '#ff7a79';
                        }
                    }

                    let textSize = [];
                    let text = [];
                    let textColor = [];

                    textSize.push(10);
                    text.push(count);
                    textColor.push('#ffffff');

                    textSize.push(8);
                    text.push(sggNm);
                    textColor.push('#333333');

                    this.simpleMap.changePathColor(escape(sggNm), fillColor);
                    this.simpleMap.addEllipse(this.groupName, lat, lng, 15, 7, 0, 0, "#688b9f", 0.4);
                    this.simpleMap.addText(this.groupName, lat, lng, textSize, textColor, text, undefined, 0.2);
                }
            }
        },
        drawAir(){
            if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                if (this.selectedTopMenu === 'Air') {
                    this.initGripSeoulSimpleMap();
                    this.$store.dispatch('SET_SHOW_SEOULMAP', true);

                    if (this.seoulMapMenu !== 'rainfall') {
                        let airQaMeta = this.airHjdMeta[this.seoulMapMenu];
                        let col = airQaMeta.sggCol;

                        for (let sggNm in $_ADM.GU_CENTER_MAP) {
                            let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                            let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;

                            let airSgg = this.airSggCenterMap[sggNm];
                            let val = '';
                            if (typeof airSgg !== $_TYPE.UNDEF) {
                                val = airSgg[col];
                            }
                            let level = airQaMeta.levelFun.call(airLevel, val);

                            let fillColor = level[3];
                            this.simpleMap.changePathColor(escape(sggNm), fillColor);

                            this.simpleMap.addText(this.groupName, lat, lng, 10, '#666666', sggNm);
                        }
                    } else {
                        for (let sggNm in $_ADM.GU_CENTER_MAP) {
                            let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                            let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;
                            let val = '';
                            if (typeof this.seoulRainfallMap[sggNm] !== $_TYPE.UNDEF) {
                                val = this.seoulRainfallMap[sggNm].threeHourSum;
                            }
                            let level = airLevel.rainfallLevel(val);

                            let fillColor = level[3];
                            this.simpleMap.changePathColor(escape(sggNm), fillColor);

                            this.simpleMap.addText(this.groupName, lat, lng, 10, '#666666', sggNm);
                        }
                    }
                }
            }
        },
        drawWater(){
            if(typeof this.simpleMap !== $_TYPE.UNDEF && this.selectedTopMenu === 'Water') {
                this.initGripSeoulSimpleMap();
                this.$store.dispatch('SET_SHOW_SEOULMAP', true);
                let selectedSubMenu = this.selectedSubMenus[0];
                if(typeof selectedSubMenu !== $_TYPE.UNDEF) {
                    for(let sggNm in $_ADM.GU_CENTER_MAP) {
                        let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                        let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;

                        let val = '';
                        if(typeof this.waterSggCenterMap[sggNm] !== $_TYPE.UNDEF){
                            val = this.waterSggCenterMap[sggNm][selectedSubMenu];
                        }
                        let level = airLevel.waterQuality(val, selectedSubMenu);

                        let fillColor = level[3];
                        this.simpleMap.changePathColor(escape(sggNm), fillColor);

                        this.simpleMap.addText(this.groupName, lat, lng, 10, '#666666', sggNm);
                    }
                }
            }
        },
        initGripSeoulSimpleMap(){
            if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                this.simpleMap.isDisplayDefaultText(false);
                this.simpleMap.changeAllPathDefaultColor();
                this.simpleMap.removeAllTextGroup();
                this.simpleMap.removeAllMarkerGroup();
                this.simpleMap.removeAllCircleGroup();
            }
        },
    },
    mixins: [simpleMapMixins],
};
</script>
